import { IonButton, IonIcon, IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar,
  IonLabel,
  IonInput
} from '@ionic/react';
import React, { useState } from 'react';
import QrReader from 'react-qr-reader';
//import { useParams } from 'react-router';
import Geo, { GeoType } from '../services/Geo';
import './Test.css';

const Test: React.FC = () => {

 // const { name } = useParams<{ name: string; }>();
 const name:string = "Test Features";
 const [loc, setLoc] = useState<string>("-");

 const geo = new Geo();
 const getLocation2 = async(e:any):Promise<GeoType> => {
    return await geo.getLocation();
 }

 getLocation2(null).then((l: GeoType) => {
    setLoc(l.lat+","+l.lon);
 });

 const [scanOn, setScanOn] = useState<boolean>(false);
 const [scanResult, setScanResult] = useState<any>("No Result");

 const handleScan = (data:any) => {
  if (data) {
    setScanResult(data);
    alert(data);
  }
 }

 const handleError = (err:any) => {
   console.error(err);
 }

 const scanOnOff = () => {
   setScanOn(!scanOn);
 }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>

      <IonLabel>
        Location
      </IonLabel>
      <IonInput value={loc}>
      </IonInput>

      <IonButton expand="block" color="primary" onClick={(e) => getLocation2(e).then((l: GeoType) => {setLoc(l.lat+","+l.lon);})}>
            Get Location
      </IonButton>
      
      {scanOn && (
      <div>
        <QrReader
          delay={300}
          onError={(e) => handleError(e)}
          onScan={(e) => handleScan(e)}
          style={{ width: '100%' }}
        />
        <p>{scanResult}</p>
      </div>
      )}
      
      <IonButton expand="full" onClick={(e) => scanOnOff()}>
        <IonIcon slot="start" name="qr-scanner"></IonIcon>
          {scanOn ? "Stop Scan" : "Start Scan"}
      </IonButton>

      </IonContent>
    </IonPage>
  );
};

export default Test;
